/**
 * Asynchronously loads the component for DormantCampaignsViewPage
 */

import { lazyLoad } from 'utils/loadable';

export const DormantCampaignsViewPage = lazyLoad(
  () => import('./index'),
  module => module.DormantCampaignsViewPage,
);
